export const renew_subscription_form_constant = {
    basic_details: {
        title: "Registered Email Address",
        sub_title: "Enter the email address used for your previous booking",
        form_fields: {
            email: {
                field_name: "email",
                placeholder: "Email",
            },
            billing_state: {
                field_name: "billing_state",
                placeholder: "State",
                placeholder_optional: "State (Optional)",
            },
        },
    },
    gst_details: {
        title: "I have a GST Number",
        form_fields: {
            active: {
                field_name: "active",
            },
            company_name: {
                field_name: "company_name",
                placeholder: "Registered Company Name",
            },
            registration_number: {
                field_name: "registration_number",
                placeholder: "GST Number",
            },
            company_address: {
                field_name: "company_address",
                placeholder: "Company Address",
            },
            company_pincode: {
                field_name: "company_pincode",
                placeholder: "Company Pincode",
            },
        },
    },
    timezone_details: {
        field_names: {
            timezone_data: "timezone_data", // the main field in the payment details form side
            timezone_data_description_section:
                "timezone_data_description_section", // duplicate field in listing details section
        },
        placeholders: {
            timezone_data: "Set Timezone",
        },
    },
};

export const renew_subscription_form_error = {
    user_invalid_error:
        "Please use the email used to make the previous booking",
};

export const renew_subscription_status_error = 4;
